import { render, staticRenderFns } from "./categorySection.vue?vue&type=template&id=1b81dadc&scoped=true&"
import script from "./categorySection.vue?vue&type=script&lang=js&"
export * from "./categorySection.vue?vue&type=script&lang=js&"
import style0 from "./categorySection.vue?vue&type=style&index=0&id=1b81dadc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b81dadc",
  null
  
)

export default component.exports